import { render, staticRenderFns } from "./MachineWarranty.vue?vue&type=template&id=318b14bd"
import script from "./MachineWarranty.vue?vue&type=script&lang=js"
export * from "./MachineWarranty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports